/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A5Inputs */

const es_marketplace_seo_spain_faq_a5 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige destino y fechas, filtra por tipo de barco o experiencia, consulta la ficha del anuncio y solicita reserva. El armador confirma los detalles antes de zarpar.`)
};

const gl_marketplace_seo_spain_faq_a5 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elixe destino e datas, filtra por tipo de barco ou experiencia, consulta a ficha do anuncio e solicita reserva. O armador confirma os detalles antes de zarpar.`)
};

const en_marketplace_seo_spain_faq_a5 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose destination and dates, filter by boat or experience type, check the listing and request a booking. The owner confirms details before you sail.`)
};

/**
* | output |
* | --- |
* | "Choose destination and dates, filter by boat or experience type, check the listing and request a booking. The owner confirms details before you sail." |
*
* @param {Marketplace_Seo_Spain_Faq_A5Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a5 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A5Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A5Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a5(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a5(inputs)
	return es_marketplace_seo_spain_faq_a5(inputs)
});